// import React from "react";
// import { TemplateHeader, TemplateFooter } from "../../Preview/SharedTemplateComponents";
// import DocumentIntro from "./DocumentIntro";
// import DocumentBody from "./DocumentBody";
// import SignatureBlock from "./SignatureBlock";
// import { shouldShowSignature, A4_WIDTH_PX, A4_HEIGHT_PX } from "../utlis/letterUtils";

// export default function LetterPage({ content, pageIndex, totalPages, scale, state, headerConfig, footerConfig, companyName, finalDrawnSignature, finalSignature }) {

//     const showSig = shouldShowSignature(pageIndex, totalPages, state.signaturePlacement, state.signaturePagePoint);

//     return (
//         <div
//             className="single-page bg-white shadow-xl mx-auto relative flex flex-col overflow-hidden"
//             style={{
//                 width: `${A4_WIDTH_PX}px`,
//                 height: `${A4_HEIGHT_PX}px`,
//                 minWidth: `${A4_WIDTH_PX}px`,
//                 minHeight: `${A4_HEIGHT_PX}px`,
//                 transform: `scale(${scale})`,
//                 transformOrigin: 'top center',
//                 marginBottom: `${-(A4_HEIGHT_PX * (1 - scale)) + 24}px`,
//                 overflow: "visible",
//                 boxShadow: "none",
//                 backgroundColor: '#ffffff',
//                 boxShadow: 'none'

//             }}
//         >
//             <TemplateHeader {...headerConfig} />

//             {/* Content section */}
//             {/* <div className="flex-1 px-20 py-8 flex flex-col text-slate-900 font-sans text-[12pt] leading-[1.6] overflow-y-auto">
//                 <div className="text-left whitespace-pre-wrap flex flex-col"> */}
//             <div
//                 className="flex-1 px-20 py-6 flex flex-col text-slate-900 font-sans text-[12pt] leading-[1.6]"
//                 style={{ overflow: "visible", minHeight: 0 }}
//             >
//                 <div
//                     className="text-left whitespace-pre-wrap flex flex-col"
//                     style={{ overflow: "visible" }}
//                 >
//                     {pageIndex === 0 && <DocumentIntro state={state} />}
//                     <DocumentBody content={content} />
//                 </div>
//             </div>

//             {/* Signature Block - with proper spacing */}
//             {showSig && (
//                  <div className="px-20 pb-2 mt-auto shrink-0">
//                     <SignatureBlock
//                         state={state}
//                         companyName={companyName}
//                         finalDrawnSignature={finalDrawnSignature}
//                         finalSignature={finalSignature}
//                         isLastPage={pageIndex === totalPages - 1}
//                     />
//                 </div>
//             )}

//             {/* Footer */}
//             <div className="w-full shrink-0">
//                 <TemplateFooter {...footerConfig} />
//             </div>
//         </div>
//     );
// }
import React from "react";
import { TemplateHeader, TemplateFooter } from "../../Preview/SharedTemplateComponents";
import DocumentIntro from "./DocumentIntro";
import DocumentBody from "./DocumentBody";
import SignatureBlock from "./SignatureBlock";
import { shouldShowSignature, A4_WIDTH_PX, A4_HEIGHT_PX } from "../utlis/letterUtils";

export default function LetterPage({
  content,
  pageIndex,
  totalPages,
  scale,
  state,
  headerConfig,
  footerConfig,
  companyName,
  finalDrawnSignature,
  finalSignature,
}) {
  const showSig = shouldShowSignature(
    pageIndex,
    totalPages,
    state.signaturePlacement,
    state.signaturePagePoint
  );

  return (
    /*
      The outer wrapper is EXACTLY A4 size and overflow:hidden.
      This is intentional — the page MUST clip at A4 boundaries for
      both the visual preview and the PDF capture to look correct.
      The pagination engine is responsible for making sure content
      fits; we do NOT rely on overflow:visible to handle overage.

      The key structural change vs the original:
        - Content area uses flex-col layout but does NOT use mt-auto on sig.
        - Signature sits at the BOTTOM of the content area, not pushed by flex.
        - This eliminates the huge gap when content is short.
    */
    <div
      className="single-page bg-white mx-auto relative flex flex-col"
      style={{
        width: `${A4_WIDTH_PX}px`,
        height: `${A4_HEIGHT_PX}px`,
        minWidth: `${A4_WIDTH_PX}px`,
        minHeight: `${A4_HEIGHT_PX}px`,
        transform: `scale(${scale})`,
        transformOrigin: "top center",
        marginBottom: `${-(A4_HEIGHT_PX * (1 - scale)) + 24}px`,
        backgroundColor: "#ffffff",
        overflow: "hidden",   // Must be hidden — page clips at A4 boundary
        boxShadow: "none",
      }}
    >
      {/* ── Header (shrink-0 so it never collapses) ── */}
      <div className="shrink-0">
        <TemplateHeader {...headerConfig} />
      </div>

      {/*
        ── Content + Signature wrapper ──────────────────────────────────────
        flex-1 so this area fills all space between header and footer.
        overflow:hidden keeps it clipped to its allocated space.
        flex-col so content and sig stack vertically.

        We use justify-between ONLY when showing a signature, so the sig
        sits at the bottom. When no sig, content starts from the top.
        This removes the huge gap that mt-auto caused previously.
      */}
   <div
        className={`flex-1 px-20 py-6 flex flex-col text-slate-900 font-sans text-[12pt] leading-[1.6] overflow-hidden ${
          showSig ? "justify-between" : ""
        }`}
        style={{ minWidth: 0 }}
      >
        {/* ── Body text ── */}
        <div className="text-left" style={{ minWidth: 0, width: "100%" }}>
          {pageIndex === 0 && <DocumentIntro state={state} />}
          <DocumentBody content={content} />
        </div>

        {/* ── Signature (only rendered when needed, sits naturally at bottom) ── */}
        {showSig && (
          <div className="shrink-0 pb-2">
            <SignatureBlock
              state={state}
              companyName={companyName}
              finalDrawnSignature={finalDrawnSignature}
              finalSignature={finalSignature}
              isLastPage={pageIndex === totalPages - 1}
            />
          </div>
        )}
      </div>

      {/* ── Footer (shrink-0 so it always sits at the very bottom) ── */}
      <div className="w-full shrink-0">
        <TemplateFooter {...footerConfig} />
      </div>
    </div>
  );
}